import { render, staticRenderFns } from "./storageDemandItems.vue?vue&type=template&id=2e4b20b2&scoped=true&"
import script from "./storageDemandItems.vue?vue&type=script&lang=js&"
export * from "./storageDemandItems.vue?vue&type=script&lang=js&"
import style0 from "./storageDemandItems.vue?vue&type=style&index=0&id=2e4b20b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b20b2",
  null
  
)

export default component.exports